import React from 'react';
import { Link, Stack, Typography, Box } from '@mui/material';
import { neutral } from '_lex/_foundations/phxColors';

export type QuickActionProps = {
  endIcon?: React.ReactNode;
  href?: string;
  id: string;
  newWindow?: boolean;
  onClick?: () => void;
  startIcon?: React.ReactNode;
  subtitle?: string;
  title?: string;
};

const QuickAction: React.FC<QuickActionProps> = ({
  endIcon,
  href,
  id,
  newWindow,
  onClick,
  startIcon,
  subtitle,
  title,
}) => {
  return (
    <Link
      data-testid={`phx-qa-${id}`}
      href={href}
      target={newWindow ? '_blank' : undefined}
      rel={newWindow ? 'noopener noreferrer' : undefined}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault();
          onClick();
        }
      }}
      sx={{
        display: 'flex',
        p: 4,
        alignItems: 'center',
        gap: 3,
        borderRadius: 2,
        border: `1px solid ${neutral[200]}`,
        backgroundColor: neutral[50],
      }}
    >
      {startIcon && (
        <Box
          sx={{
            display: 'inline-flex',
            width: 48,
            flex: '0 0 48px',
            height: 48,
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 999,
            border: `1px solid ${neutral[200]}`,
            backgroundColor: neutral[25],
          }}
        >
          {startIcon}
        </Box>
      )}
      <Stack>
        {title && (
          <Typography
            variant='subtitle1'
            sx={{
              color: neutral[900],
            }}
          >
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography
            variant='body1'
            sx={{
              color: neutral[600],
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Stack>
      {endIcon && (
        <Box
          sx={{
            display: 'inline-flex',
            ml: 'auto',
            width: 16,
            height: 16,
            alignItems: 'center',
            justifyContent: 'center',
            color: neutral[400],
          }}
        >
          {endIcon}
        </Box>
      )}
    </Link>
  );
};

export default QuickAction;
